import type { Order } from "../../../../../../../services";

const cellProcessing = (item: Order.Model["checkCard"]): string =>
	item?.code?.value ?? "";

export default cellProcessing;
